export const environment = {
  production: true,
  urlGix: 'https://api.bcr.com.ar/gix/index.html',
  urlMaestros: 'https://api.bcr.com.ar/maestros/index.html',
  urlMuvin: 'https://api.bcr.com.ar/muvin/index.html'
};